module.exports = __webpack_public_path__ + "static/garage_night_mobile-9fca4b7d4a947fab8365d0785f87e58d.jpg";